<template>
  <div class="custom-carousel-wrapper">
    <!-- 轮播容器 -->
    <div class="carousel-container" @mouseenter="pauseAutoPlay" @mouseleave="startAutoPlay">
      <!-- 图片列表 -->
      <div class="carousel-track" :style="trackStyle">
        <!-- 循环渲染双倍图片实现无缝衔接 -->
        <div
          v-for="(item, index) in duplicatedItems"
          :key="index"
          class="carousel-item"
          @click="goInfo()"
        >
          <img src="@/assets/icon_banner1.png" alt>
          <span>专用完全培养基</span>
        </div>
      </div>
      <div class="arrows">
        <img src="@/assets/icon_left.png" @click="left()">
        <img src="@/assets/icon_right.png" @click="right()">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true }, // 原始图片数组
    interval: { type: Number, default: 2000 }, // 轮播间隔
    transition: { type: Number, default: 500 } // 过渡时间
    
  },
  data() {
    return {
      currentIndex: 0, // 当前索引
      timer: null, // 定时器
      isTransitioning: true // 是否启用过渡
    };
  },
  computed: {
    // 复制图片数组实现无缝滚动
    duplicatedItems() {
      return [...this.items, ...this.items];
    },

    // 轨道transform样式
    trackStyle() {
      return {
        transform: `translateX(-${this.currentIndex * 25}%)`,
        transition: this.isTransitioning
          ? `transform ${this.transition}ms ease`
          : "none"
      };
    }
  },
  mounted() {
    this.startAutoPlay();
  },
  methods: {
    goInfo() {
      this.$router.push({ path: "/cellslineinfo" }, () => {}, () => {});
    },
    // 启动自动播放
    startAutoPlay() {
      this.timer = setInterval(() => {
        this.slideNext();
      }, this.interval);
    },

    // 暂停自动播放
    pauseAutoPlay() {
      clearInterval(this.timer);
    },

    // 滑动到下一张
    slideNext() {
      this.isTransitioning = true;
      this.currentIndex++;

      // 当滑动到复制的第一组末尾时
      if (this.currentIndex >= this.items.length) {
        setTimeout(() => {
          this.isTransitioning = false;
          this.currentIndex = 0; // 无缝跳转到初始位置
        }, this.transition);
      }
    },
    left() {
      this.slidePrev();
    },
    right() {
      this.slideNext();
    },
    slidePrev() {
      if (this.currentIndex <= 0) {
        this.isTransitioning = false;
        this.currentIndex = this.items.length;
        setTimeout(() => {
          this.isTransitioning = true;
          this.currentIndex--;
        }, 50);
      } else {
        this.currentIndex--;
      }
    }
  }
};
</script>

<style scoped>
.custom-carousel-wrapper {
  overflow: hidden;
  position: relative;
  margin-left: 18%;
  margin-right: 18%;
}

.carousel-container {
  width: 100%;
  position: relative;
  padding-bottom: 330px; /* 保持16:9比例 */
}

.carousel-track {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%; /* 双倍宽度容纳重复图片 */
  display: flex;
  height: 330px;
}

.carousel-item {
  flex: 0 0 24%; /* 每张占25%宽度 */
  width: 280px;
  height: 330px;
  box-sizing: border-box;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
}

.carousel-item img {
  width: 100%;
  height: 280px;
  object-fit: cover;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
.carousel-item span {
  height: 50px;
  width: 280px;
  text-align: center;
  font-size: 16px;
  line-height: 50px;
  color: #333333;
}
.arrows {
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  top: 35%;
}
</style>